/**
 * @file src/components/ExplanationSection.tsx
 * Explainer card: how-it-works video, 3-step usage list, feature highlights.
 * The primary WhatsApp CTA lives upstream in SessionInput, so this section
 * focuses on educating new users — no second CTA here.
 */

import { Box, Typography, Paper } from '@mui/material'

export const ExplanationSection = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4, width: '100%', maxWidth: '600px', mx: 'auto' }}>
      {/* Video and Features */}
      <Paper
        elevation={0}
        sx={{
          p: 4,
          borderRadius: 3,
          border: '1px solid',
          borderColor: 'grey.200',
          bgcolor: 'white'
        }}
      >
        <Typography variant="h6" sx={{ mb: 3, color: '#1E2A3B', fontWeight: 600, textAlign: 'center' }}>
          How it works
        </Typography>
        <Box sx={{ 
          position: 'relative',
          width: '100%',
          maxWidth: '300px',
          mx: 'auto',
          mb: 4
        }}>
          <Box sx={{ 
            position: 'relative',
            paddingTop: '177.77%', // 16:9 Aspect Ratio for vertical video
            borderRadius: 2,
            overflow: 'hidden',
            bgcolor: '#F8FAFC'
          }}>
            <iframe
              src="https://www.youtube.com/embed/0WdAXETt4yM"
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: 0
              }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </Box>
        </Box>

        {/* How to Steps */}
        <Typography variant="h6" sx={{ color: '#1E2A3B', mb: 2, fontWeight: 600, textAlign: 'center' }}>
          How to use
        </Typography>
        <Box component="ol" sx={{ 
          color: '#1E2A3B',
          pl: 2,
          maxWidth: '400px',
          mx: 'auto',
          mb: 4,
          '& > li': {
            mb: 2,
            pl: 1,
            '&:last-child': { mb: 0 }
          }
        }}>
          <li>Forward your pictures to Fowix on WhatsApp</li>
          <li>Send "ok" when you're done sending pictures</li>
          <li>Click the link we send you to access your pictures</li>
        </Box>

        {/* Features */}
        <Typography variant="h6" sx={{ color: '#1E2A3B', mb: 2, fontWeight: 600, textAlign: 'center' }}>
          Features
        </Typography>
        <Box component="ul" sx={{ 
          color: '#1E2A3B',
          pl: 2,
          maxWidth: '400px',
          mx: 'auto',
          '& > li': {
            mb: 1,
            '&:last-child': { mb: 0 }
          }
        }}>
          <li>Select specific images to include in your PDF</li>
          <li>Drag and drop to reorder images exactly how you want</li>
          <li>Download your PDF instantly to your device</li>
          <li>Send the PDF directly to your email</li>
        </Box>
      </Paper>
    </Box>
  )
} 